// External libraries
import React from 'react';
import { useStoreState } from '@/store';
// @ts-expect-error TODO this was working pre typescript
import { FloatingLabelInput } from '@checkout/react-components';

// Internal modules
import { getContent } from '@/lib';
import { useMountLogging } from '@/lib/reactHooks';
import { validationFunctionMap } from './validation';

export type SecondaryIdentityDocumentNumberProps = {
  blurHandler?: (e: React.FocusEvent<HTMLInputElement>) => void;
  changeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
  focusHandler?: (e: React.FocusEvent<HTMLInputElement>) => void;
};

const SecondaryIdentityDocumentNumber = (
  props: SecondaryIdentityDocumentNumberProps,
): JSX.Element => {
  useMountLogging('SecondaryIdentityDocumentNumber');
  const secondaryIdentityDocumentNumber = useStoreState(
    ({ form }) => form.secondaryIdentityDocumentNumber,
  );
  const secondaryIdentityDocumentType = useStoreState(
    ({ form }) => form.secondaryIdentityDocumentType?.value,
  );

  return (
    <FloatingLabelInput
      blurHandler={props.blurHandler}
      changeHandler={props.changeHandler}
      data-testid="secondaryIdentityDocumentNumber"
      focusHandler={props.focusHandler}
      id="secondaryIdentityDocumentNumber"
      label={getContent('fieldLabels.secondaryIdentityDocumentNumber')}
      required={true}
      // @ts-expect-error TODO: type validationFunctionMap
      validationFn={validationFunctionMap[secondaryIdentityDocumentType]}
      {...secondaryIdentityDocumentNumber}
    />
  );
};

export { SecondaryIdentityDocumentNumber };
